import { render, staticRenderFns } from "./SaleCounts.vue?vue&type=template&id=bc96026e&"
import script from "./SaleCounts.vue?vue&type=script&lang=js&"
export * from "./SaleCounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports